module.exports = __webpack_public_path__ + "img/dp-jy-sy16.11704c97.png";